import { EmergencyMessageComponent } from "front-end/components/emergency-message/emergency-message.component";

export class EmergencyMessageService {
    private _currentContext: JQuery = $();

    private LOCAL_STORAGE_EMERGENCY_MESSAGE_HASH: string = "EmergencyMeccage.Hash";

    private _emergencyMessageComponent: EmergencyMessageComponent = null;

    private handleClose(): void {
        this._emergencyMessageComponent.hide();
        localStorage.setItem(this.LOCAL_STORAGE_EMERGENCY_MESSAGE_HASH, this._emergencyMessageComponent.getHash());
    }

    private bindEvents(): void {
        const emergencyMessageStoredHashValue = localStorage.getItem(this.LOCAL_STORAGE_EMERGENCY_MESSAGE_HASH);
        const emergencyMessageCurrentHashValue = this._emergencyMessageComponent.getHash();

        if (emergencyMessageStoredHashValue !== emergencyMessageCurrentHashValue) {
            this._emergencyMessageComponent.show();
        }

        this._emergencyMessageComponent.on("close")
            .subscribe(() => this.handleClose());
    }

    private clearEmergencyMessageStorage(): void {
        localStorage.removeItem(this.LOCAL_STORAGE_EMERGENCY_MESSAGE_HASH);
    }

    private parseContext(): void {
        const emergencyMessageContext = $(EmergencyMessageComponent.SELECTOR, this._currentContext);

        const emergencyMessageComponent = new EmergencyMessageComponent();
        emergencyMessageComponent.init(emergencyMessageContext);
        this._emergencyMessageComponent = emergencyMessageComponent;
    }

    public init(context: JQuery, isEmergencyMessageActive: boolean): void {
        this._currentContext = context || this._currentContext;

        if (!isEmergencyMessageActive) {
            this.clearEmergencyMessageStorage();
            return;
        }

        this.parseContext();
        this.bindEvents();
    }
}
